import { NgModule } from '@angular/core';
import { PageHeaderComponent } from './page-header/page-header.component';
import { SectionCardComponent } from './section-card/section-card.component';
import { StatusBadgeComponent } from './status-badge/status-badge.component';
import { CopyButtonComponent } from './copy-button/copy-button.component';
import { EnvironmentBadgeComponent } from './environment-badge/environment-badge.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { ConsoleSectionComponent } from './console-section/console-section.component';

@NgModule({
  imports: [
    PageHeaderComponent,
    ConsoleSectionComponent,
    SectionCardComponent,
    StatusBadgeComponent,
    CopyButtonComponent,
    EnvironmentBadgeComponent,
    EmptyStateComponent,
  ],
  exports: [
    PageHeaderComponent,
    ConsoleSectionComponent,
    SectionCardComponent,
    StatusBadgeComponent,
    CopyButtonComponent,
    EnvironmentBadgeComponent,
    EmptyStateComponent,
  ],
})
export class SharedUiModule {}
